import { List } from 'immutable';
import Gbp from 'records/Gbp';
import GbpLocation from 'records/GbpLocation';
import { GBP_STEPS } from 'constants/gbp';

import {
  GBP_RESET_STATE,
  GBP_ASYNC_ACTION_START,
  GBP_ASYNC_ACTION_ERROR_RESET,
  GBP_SEARCH_LOCATIONS_SUCCESS,
  GBP_SET_MODAL_VISIBILITY,
  GBP_AUTH_SUCCESS,
  GBP_ALERT_VISIBILITY,
  GBP_USER_LOCATIONS_SUCCESS,
  GBP_LOCATION_VERIFICATION_ASYNC_ACTION_START,
  GBP_USER_LOCATION_ASYNC_ACTION_START,
  GBP_USER_LOCATION_ASYNC_ACTION_ERROR,
  GBP_ASYNC_SUCCESS,
  GBP_CREATE_LOCATION_SUCCESS,
  GBP_SET_LOCATION_DATA,
  GBP_CHANGE_LOCATION_DATA,
  GBP_RESET_LOCATION,
  GBP_SUCCESS_ALERT,
  GBP_FAILURE_ALERT,
  GBP_ASYNC_SEARCH_START,
  GBP_LOCATION_VERIFICATION_METHOD_ASYNC_ACTION_ERROR,
  GBP_LOCATION_VERIFICATION_METHOD_ASYNC_ACTION_START,
  GBP_LOCATION_VERIFICATION_METHOD_SUCCESS,
  GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_ASYNC_ACTION_START,
  GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_ASYNC_ACTION_ERROR,
  GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_SUCCESS,
  SUBMIT_VERIFICATION_CODE_ASYNC_ACTION_START,
  SUBMIT_VERIFICATION_CODE_SUCCESS,
  GBP_ASYNC_ERROR,
} from 'actions/gbp';

const initialState = new Gbp();

const actionsMap = {
  [GBP_RESET_STATE]: () => initialState,
  [GBP_ASYNC_ACTION_START]: state => state.merge({
    loading: true,
    errorMessage: '',
    searchLocations: new List(),
    createdLocation: new List(),
  }),
  [GBP_ASYNC_SEARCH_START]: state => state.merge({
    isSearchLoading: true,
    errorMessage: '',
    searchLocations: new List(),
  }),
  [GBP_USER_LOCATION_ASYNC_ACTION_START]: state => state.merge({
    loading: true,
    errorMessage: '',
    userLocations: new List(),
  }),
  [GBP_LOCATION_VERIFICATION_ASYNC_ACTION_START]: state => state.merge({
    loading: true,
    errorMessage: ''
  }),
  [GBP_LOCATION_VERIFICATION_METHOD_ASYNC_ACTION_START]: state => state.merge({
    loading: true,
    errorMessage: '',
    verificationMethodsOfSelectedLocation: new List(),
  }),
  [GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_ASYNC_ACTION_START]: state => state.merge({
    loading: true,
    errorMessage: '',
    verificationProcessEntity: null,
  }),
  [SUBMIT_VERIFICATION_CODE_ASYNC_ACTION_START]: state => state.merge({
    loading: true,
    errorMessage: '',
  }),
  [GBP_ASYNC_ACTION_ERROR_RESET]: (state, action) => state.merge({
    loading: false,
    isSearchLoading: false,
    errorMessage: action.error,
    searchLocations: new List(),
    createdLocation: new List(),
  }),
  [GBP_USER_LOCATION_ASYNC_ACTION_ERROR]: (state, action) => state.merge({
    loading: false,
    errorMessage: action.error,
    userLocations: new List(),
  }),
  [GBP_ASYNC_ERROR]: (state, action) => state.merge({
    loading: false,
    errorMessage: action.error,
  }),
  [GBP_LOCATION_VERIFICATION_METHOD_ASYNC_ACTION_ERROR]: (state, action) => state.merge({
    loading: false,
    errorMessage: action.error,
    verificationMethodsOfSelectedLocation: new List(),
  }),
  [GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_ASYNC_ACTION_ERROR]: (state, action) => state.merge({
    loading: false,
    errorMessage: action.error,
    verificationProcessEntity: null,
  }),
  [GBP_SEARCH_LOCATIONS_SUCCESS]: (state, action) => state.merge({
    isSearchLoading: false,
    searchLocations: action.payload,
  }),
  [GBP_USER_LOCATIONS_SUCCESS]: (state, action) => state.merge({
    loading: false,
    userLocations: action.payload,
  }),
  [GBP_LOCATION_VERIFICATION_METHOD_SUCCESS]: (state, action) => state.merge({
    loading: false,
    verificationMethodsOfSelectedLocation: action.payload,
  }),
  [GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_SUCCESS]: (state, action) => state.merge({
    loading: false,
    isModalOpen: true,
    verificationProcessEntity: action.payload,
  }),
  [SUBMIT_VERIFICATION_CODE_SUCCESS]: (state) => state.merge({
    loading: false,
    isModalOpen: true,
    step: GBP_STEPS.SUCCESS,
  }),
  [GBP_SET_MODAL_VISIBILITY]: (state, action) => state.merge({
    isModalOpen: action.payload.isVisible,
    step: action.payload.step,
    errorMessage: action.payload.clearErrors ? '' : state.errorMessage,
  }),
  [GBP_AUTH_SUCCESS]: (state, action) => state.merge({
    loading: false,
    isModalOpen: true,
    step: GBP_STEPS.SEARCH,
  }),
  [GBP_ALERT_VISIBILITY]: (state, action) => state.merge({
    loading: false,
    isModalOpen: action.payload.isModalOpen,
    isAlertModalOpen: action.payload.isVisible
  }),
  [GBP_ASYNC_SUCCESS]: (state) => state.merge({
    loading: false,
  }),
  [GBP_CREATE_LOCATION_SUCCESS]: (state, action) => state.merge({
    loading: false,
    createdLocation: action.payload
  }),
  [GBP_SET_LOCATION_DATA]: (state, action) => state.merge({
    loading: false,
    location: new GbpLocation(action.payload),
  }),
  [GBP_CHANGE_LOCATION_DATA]: (state, action) => {
    const location = state.get('location');
    const { key, value } = action.payload;

    return state.merge({
      location: location.set(key, value),
    })
  },
  [GBP_RESET_LOCATION]: state => state.merge({
    location: new GbpLocation(),
  }),
  [GBP_SUCCESS_ALERT]: (state, action) => state.merge({
    loading: false,
    successAlert: action.payload.isVisible,
    isLinkLocation: action.payload.isLinkLocation,
  }),
  [GBP_FAILURE_ALERT]: (state, action) => state.merge({
    loading: false,
    failureAlert: action.payload.isVisible,
    isLinkLocation: action.payload.isLinkLocation,
  }),  
};

export default function gbp(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
